export const isFilterIndicatorTarget = (target: EventTarget | null): boolean =>
  target instanceof Element &&
  target.closest('.MuiAutocomplete-clearIndicator, .MuiAutocomplete-popupIndicator') !== null;
